import React from 'react'
import { Modal } from '@components/ui'

type NotesDownloadNoteModalProps = {
  show: boolean
  noteName: string
  onCancel: () => void
  onDownload: () => void
}

const NotesDownloadNoteModal: React.FC<NotesDownloadNoteModalProps> = ({
  show,
  noteName,
  onCancel,
  onDownload,
}) => {
  const name = noteName.trim() || 'this note'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      className="notes-ds-confirm"
      title="Download note"
      description={`You are about to download a PDF copy of ${name}. Do you want to proceed?`}
      primaryLabel="Download"
      secondaryLabel="Cancel"
      onPrimaryClick={onDownload}
      onSecondaryClick={onCancel}
    />
  )
}

export default NotesDownloadNoteModal
